module.exports = __webpack_public_path__ + "img/logo26.01ebdca8.png";